exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.task-content[data-v-dcb188d0],\n.task-result[data-v-dcb188d0] {\n  line-height: 1.5;\n  word-break: break-word;\n}\n\n/* 表格单元格文本溢出处理 */\n.el-table .cell[data-v-dcb188d0] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n/* 确保tooltip正常显示 */\n.el-tooltip__popper[data-v-dcb188d0] {\n  max-width: 400px;\n  word-break: break-all;\n  line-height: 1.5;\n}\n\n/* 状态标签样式 */\n.el-tag[data-v-dcb188d0] {\n  margin: 0;\n}\n\n/* 搜索表单样式 */\n.avue-crud__search .el-form-item[data-v-dcb188d0] {\n  margin-bottom: 18px;\n}\n", ""]);

// exports
